import React from 'react'
import { do_action } from '../../actions'
import { instanceOf } from 'prop-types'
import { Cookies } from 'react-cookie'
import {setCustomer} from '../../actions/index';

const cookies = new Cookies()

class ModalSignIn extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            warningMessage: ''
        }
    }

    changeInput = (property, event) => {
        this.setState({ [property]: event.target.value });
    }

    signIn = (e) => {
        e.preventDefault();
        let {dispatch} = this.props;
        let { email, password } = this.state;
        if (!email) {
            return this.setState({ warningMessage: 'Please enter email' });
        }
        if (!password) {
            return this.setState({ warningMessage: 'Please enter your password' });
        }
        do_action('customer_sign_in', { email, password })
            .then(data => {
                if (data.signal) {
                    cookies.set('customer', data.data.token, { path: '/', maxAge: 96969696 })
                    let $ = window.$
                    $('#modal-sign-in').modal('hide');
                    dispatch(setCustomer(data.data.customer));
                } else {
                    this.setState({ warningMessage: data.message })
                }
            })
            .catch(err => console.log(err))
    }

    render() {
        return (
            <div className="modal fade" id="modal-sign-in" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="signin-ruhu">
                        <div className="cont3nt-body">
                            <div className="title">
                                <div className="text">Sign in</div>
                                <a href="#" className="cancel" data-dismiss="modal">Cancel</a>
                            </div>
                            <form onSubmit={this.signIn.bind(this)}>
                                <div className="content">
                                    <div className="form-group">
                                        <input type="email" ref="email" value={this.state.email} onChange={this.changeInput.bind(this, 'email')} className="form-control input-mixx input-mixx-email" placeholder="Email" />
                                    </div>
                                    <div className="form-group">
                                        <input type="password" value={this.state.password} onChange={this.changeInput.bind(this, 'password')} className="form-control input-mixx input-mixx-password" placeholder="Password" />
                                    </div>
                                    <p className="text-danger">{this.state.warningMessage}</p>
                                    <button type="submit" className="bg-blue action" style={{width: '100%'}}>Sign In</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalSignIn